import { render, staticRenderFns } from "./coinManager.vue?vue&type=template&id=1d82034c&"
import script from "./coinManager.vue?vue&type=script&lang=js&"
export * from "./coinManager.vue?vue&type=script&lang=js&"
import style0 from "./coinManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports